import $ from 'jquery';
export class Gallery {
    constructor() {
        this.selector = '.gallery-item';
        if ($(this.selector).length === 0)
            return;
        $(this.selector).magnificPopup({
            delegate: 'a',
            type: 'image',
            mainClass: "mfp-fade",
            gallery: {
                enabled: true
            }
        });
    }
}
